<template>
  <div class="layout" id="myComponentDiv">
    <div class="box-titulo">Conversiones</div>
    <div class="box-container">
      <div class="box-filtres">
        <table>
          <tbody>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <div>RFC Del Cliente</div>
                        <input
                          type="text"
                          class="form-control"
                          autocomplete="off"
                          v-model="cliente"
                          style="text-transform: uppercase"
                          v-on:keypress="GLOBAL.SOLO_ALFANUMERICOS"
                          @keyup.enter="getTerceroByRFC"
                        />
                      </td>
                      <td style="vertical-align: bottom">
                        <button
                          class="btn btn-warning"
                          @click="getTerceroByRFC"
                        >
                          <i class="fa-solid fa-magnifying-glass"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td width="250px">
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <div>Placa</div>
                        <input
                          type="text"
                          class="form-control"
                          autocomplete="off"
                          v-model="placa"
                          style="text-transform: uppercase"
                          v-on:keypress="GLOBAL.SOLO_ALFANUMERICOS"
                          @keyup.enter="getVehiculosPorPlaca"
                        />
                      </td>
                      <td style="vertical-align: bottom">
                        <button
                          class="btn btn-warning"
                          @click="getVehiculosPorPlaca"
                        >
                          <i class="fa-solid fa-magnifying-glass"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td width="40px" style="vertical-align: bottom; padding: 7px">
                <div v-if="loading">
                  <img src="dist/img/kubber-loading.gif" style="width: 30px" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <table width="100%">
          <tbody>
            <tr>
              <td colspan="2" class="pad10">
                <div class="font-oswald">
                  <div>Conversión:</div>
                  <div
                    style="
                      font-size: 30px;
                      margin-top: -10px;
                      font-weight: bold;
                      margin-bottom: 8px;
                    "
                  >
                    <div v-if="conversion.movimiento_id != 0">
                      {{ conversion.movimiento_prefijo }}-{{
                        conversion.movimiento_consecutivo
                      }}
                    </div>
                    <div v-else>[Borrador]</div>
                  </div>
                </div>
                <hr />

                <div class="row">
                  <div class="col-lg-6 col-md-6">
                    <div>CLIENTE</div>
                    <div
                      class="font-oswald"
                      style="
                        font-weight: bold;
                        font-size: 30px;
                        margin-top: -10px;
                        text-transform: uppercase;
                      "
                    >
                      {{ tercero.persona_nombres }}&nbsp;{{
                        tercero.persona_apellidos
                      }}
                    </div>
                    <div style="text-transform: uppercase">
                      RFC: {{ tercero.persona_nit }}
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6">
                    <div>PLACA</div>
                    <div
                      class="font-oswald"
                      style="
                        font-weight: bold;
                        font-size: 30px;
                        margin-top: -10px;
                        text-transform: uppercase;
                      "
                    >
                      {{ vehiculo.placa }}&nbsp;
                    </div>
                    <div style="text-transform: uppercase">
                      MARCA / LINEA: {{ vehiculo.atributos.marca }}
                    </div>
                    <div style="text-transform: uppercase">
                      <i class="fa-regular fa-circle-user"></i>
                      {{ vehiculo.atributos.propietario_codigo }}
                      - {{ vehiculo.atributos.propietario_nombre }}
                    </div>
                    <div>
                      CHIP ACTUAL:
                      <span style="color: blue; font-weight: bold">
                        {{ vehiculo.identificador_codigo }} </span
                      >&nbsp;&nbsp;
                      <button
                        class="btn btn-sm btn-secondary"
                        @click="copyIbutton"
                      >
                        <i class="fa-solid fa-copy"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <br />
                <hr />
                <br />
                <div class="row">
                  <div class="col-lg-2 col-md-6">
                    <div>FECHA MANTENIMIENTO</div>
                    <div>
                      <input
                        class="form-control center"
                        type="text"
                        datatype="fecha"
                        autocomplete="off"
                        id="fecha_mantenimiento"
                        readonly="true"
                      />
                    </div>
                  </div>

                  <div class="col-lg-2 col-md-6">
                    <div>FECHA DE REVISIÓN</div>
                    <div>
                      <input
                        class="form-control center"
                        type="text"
                        datatype="fecha"
                        autocomplete="off"
                        id="fecha_revision"
                        readonly="true"
                      />
                    </div>
                  </div>

                  <div class="col-lg-2 col-md-6">
                    <div>NUEVO CHIP:</div>
                    <div>
                      <input
                        class="form-control"
                        type="text"
                        v-model="conversion.chip_asignado"
                      />
                    </div>
                  </div>

                  <div class="col-lg-6 col-md-6">
                    <div>MARCA KIT (CONVERSIÓN)</div>
                    <div>
                      <input
                        class="form-control"
                        type="text"
                        v-model="conversion.marca_kit"
                      />
                    </div>
                  </div>
                </div>

                <div>
                  <div>OBSERVACIONES</div>
                  <div>
                    <textarea
                      class="form-control"
                      style="height: 60px"
                      v-model="conversion.observaciones"
                    ></textarea>
                  </div>

                  <br />
                  <div
                    style="
                      background-color: rgb(208, 208, 208);
                      padding: 10px 5px;
                    "
                  >
                    <table width="100%">
                    <tbody>
                      <tr>
                        <td width="1px">
                          <button class="btn btn-info" @click="reValidar">
                            <i class="fa-regular fa-floppy-disk"></i> Guardar
                          </button>
                        </td>
                        <td>
                          <div style="padding: 10px">
                            {{ mensaje }}
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <br />

                  <div>
                    <i class="fa-solid fa-paperclip"></i>
                    ADJUNTAR DOCUMENTOS
                  </div>
                  <div style="min-height: 250px">
                    <table class="table table-striped">
                        <tbody>
                      <tr>
                        <th colspan="2">DOCUMENTOS</th>
                      </tr>
                      <tr>
                        <td width="300px">PRE-CONVERSIÓN</td>
                        <td>
                          <input
                            type="file"
                            :disabled="conversion.bloqueo"
                            @change="archivo1"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>CERTIFICADO CILINDRO</td>
                        <td>
                          <input
                            type="file"
                            :disabled="conversion.bloqueo"
                            @change="archivo2"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>CERTIFICADO KIT DE CONVERSIÓN</td>
                        <td>
                          <input
                            type="file"
                            :disabled="conversion.bloqueo"
                            @change="archivo3"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>PRUEBA DE HERMETICIDAD</td>
                        <td>
                          <input
                            type="file"
                            :disabled="conversion.bloqueo"
                            @change="archivo4"
                          />
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <br />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="!permiso_lista">
        {{ this.person.nombre }}, {{ this.GLOBAL.MENSAJE.SIN_AUTORIZACION }}
      </div>
    </div>
  </div>
</template>

<script>
import GLOBAL from "../../Global.js";
import VehiculoService from "./VehiculoService.js";

export default {
  data() {
    return {
      GLOBAL,
      person: null,
      vehiculo: null,
      tercero: null,
      cliente: "1042441916",
      placa: "MANTT0",
      loading: false,
      conversion: null,
      disableBotonGuardar: true,
      mensaje: "",
    };
  },
  components: {},
  created() {
    this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY));
    this.permiso_lista = this.person.funciones.includes(
      GLOBAL.PERMISOS.REPORTE.HOROMETRO
    );

    this.reporteService = new VehiculoService();

    this.resetDatosVehiculos();
    this.resetDatosPersona();
    this.resetConversion();

    this.mensaje = "Llene los datos para crear la conversión";
  },
  mounted() {
    $("input[datatype='fecha']").datepicker();
  },
  methods: {
    copyIbutton() {
      this.conversion.chip_asignado = this.vehiculo.identificador_codigo;
    },

    reValidar() {
      var validacion = "OK";

      this.conversion.fecha_revision = $("#fecha_revision").val();
      this.conversion.fecha_mantenimiento = $("#fecha_mantenimiento").val();

      if (this.conversion.fecha_revision.trim() == "") {
        validacion = "Se requiere la fecha de revisión";
      }

      if (this.conversion.fecha_mantenimiento.trim() == "") {
        validacion = "Se requiere la fecha de mantenimiento";
      }

      if (this.conversion.marca_kit.trim() == "") {
        validacion = "Se requiere la marca del kit de conversión";
      }

      if (this.conversion.chip_asignado.trim() == "") {
        validacion = "Se requiere un chip ibutton";
      } else if (this.conversion.chip_asignado.length != 16) {
        validacion = "Formato de chip ibutton invalido";
      }

      if (this.vehiculo._id == 0) {
        validacion = "Se requiere un vehículo";
      } else {
        this.conversion.vehiculo_id = this.vehiculo._id;
      }

      if (this.tercero.tercero_id == 0) {
        validacion = "Se requiere un cliente";
      } else {
        this.conversion.tercero_id = this.tercero.tercero_id;
        this.conversion.tercero_nombre = this.tercero.persona_nombres;
        this.conversion.tercero_nit = this.tercero.persona_nit;
      }

      if (validacion == "OK") {
        this.mensaje = "";
        this.disableBotonGuardar = false;
        this.crearConversion();
      } else {
        this.mensaje = validacion;
      }
    },

    resetConversion() {
      this.conversion = {};
      this.conversion.bloqueo = true;
      this.conversion.movimiento_id = 0;
      this.conversion.movimiento_prefijo = "";
      this.conversion.movimiento_consecutivo = "";
      this.conversion.fecha_mantenimiento = "";
      this.conversion.fecha_revision = "";
      this.conversion.chip_asignado = "";
      this.conversion.marca_kit = "";
      this.conversion.observaciones = "";
    },

    resetDatosVehiculos() {
      this.vehiculo = {};
      this.vehiculo._id = 0;
      this.vehiculo.placa = "";
      this.vehiculo.vin = "";
      this.vehiculo.identificador_codigo = "";
      this.vehiculo.atributos = {};
      this.vehiculo.atributos.propietario_codigo = "";
      this.vehiculo.atributos.propietario_nombre = "";
      this.vehiculo.atributos.marca = "";
      this.vehiculo.atributos.modelo = "";
      this.vehiculo.atributos.potencia = "";
      this.vehiculo.atributos.servicio = "";
    },

    resetDatosPersona() {
      this.tercero = {};
      this.tercero.tercero_id = 0;
      this.tercero.persona_id = "";
      this.tercero.persona_nombres = "";
      this.tercero.persona_apellidos = "";
      this.tercero.persona_nit = "";
    },

    getTerceroByRFC() {
      this.loading = true;
      var identificacion = btoa(GLOBAL.SECRET_KEY + btoa(this.cliente));
      console.log(identificacion);
      this.reporteService
        .getTerceroByRFC(this.person, identificacion)
        .then((data) => {
          console.log(data);
          if (data.status == 200) {
            this.cliente = "";
            this.tercero = data.data;
          } else {
            this.mensaje = "No fué posible realizar la operación";
          }
          this.loading = false;
        });
    },

    getVehiculosPorPlaca() {
      this.loading = true;
      var identificacion = btoa(GLOBAL.SECRET_KEY + btoa(this.placa));
      console.log(identificacion);
      this.reporteService
        .getVehiculosPorPlaca(this.person, identificacion)
        .then((data) => {
          console.log(data);
          if (data.status == 200) {
            this.placa = "";
            this.vehiculo = data.data;

            if (this.vehiculo._id > 0) {
              this.conversion.vehiculo_id = this.vehiculo.vehiculo_id;
              this.conversion.fecha_mantenimiento =
                this.vehiculo.fecha_mantenimiento;
              this.conversion.fecha_revision = this.vehiculo.fecha_revision;
              $("#fecha_mantenimiento").val(this.vehiculo.fecha_mantenimiento);
              $("#fecha_revision").val(this.vehiculo.fecha_revision);
            }

            if (this.vehiculo.identificador_id > 0) {
              this.conversion.identificador_id = this.vehiculo.identificador_id;
            }

            if (this.vehiculo.movimiento_id > 0) {
              this.conversion.movimiento_id = this.vehiculo.movimiento_id;
              this.conversion.movimiento_prefijo =
                this.vehiculo.movimiento_prefijo;
              this.conversion.movimiento_consecutivo =
                this.vehiculo.movimiento_consecutivo;
              this.conversion.movimiento_uniqueid =
                this.vehiculo.movimiento_uniqueid;

              if (this.conversion.movimiento_id != 0) {
                this.conversion.bloqueo = false;
              } else {
                this.conversion.bloqueo = true;
              }
            }

            if (this.vehiculo.tercero_id > 0) {
              this.tercero.tercero_id = this.vehiculo.tercero_id;
              this.tercero.persona_id = this.vehiculo.persona_id;
              this.tercero.persona_nombres = this.vehiculo.persona_nombres;
              this.tercero.persona_apellidos = this.vehiculo.persona_apellidos;
              this.tercero.persona_nit = this.vehiculo.persona_nit;
            }

            if (this.vehiculo.parametro_id > 0) {
              this.conversion.parametro_id = this.vehiculo.parametro_id;
            }
          } else {
            this.resetDatosVehiculos();
            this.mensaje = "No fué posible realizar la operación";
          }
          this.loading = false;
        });
    },

    crearConversion() {
      this.reporteService
        .crearConversion(this.person, this.conversion)
        .then((data) => {
          if (data.status == 200) {
            this.cliente = "";
            this.tercero = data.data;
          } else {
            this.mensaje = "No fué posible realizar la operación";
          }
          this.loading = false;
        });
    },
  },
};
</script>
